import React from 'react'

import Base from '../_Base'

const IndiaU = (props) => (
  <Base width="29" height="22" viewBox="0 0 29 22" fill="none" {...props}>
    <path
      d="M26.6036 0C27.8511 0.000169362 28.7943 1.12999 28.5714 2.35742L25.2979 20.3574C25.125 21.3084 24.2967 22 23.3302 22H2.39656C1.14884 22 0.205758 20.8702 0.428784 19.6426L3.70124 1.64258C3.87415 0.691597 4.70245 0 5.66902 0H26.6036Z"
      fill="#4A4E58"
      fillOpacity="0.7"
    />
    <path
      d="M17.843 6.31818H19.6875L18.5838 12.9702C18.4645 13.6993 18.1861 14.3407 17.7486 14.8942C17.3144 15.4477 16.7609 15.8802 16.088 16.1918C15.4152 16.5 14.6662 16.6541 13.8409 16.6541C13.009 16.6541 12.3096 16.5 11.7429 16.1918C11.1761 15.8802 10.7668 15.4477 10.5149 14.8942C10.2663 14.3407 10.2017 13.6993 10.321 12.9702L11.4247 6.31818H13.2692L12.1903 12.8161C12.1207 13.2403 12.1522 13.6181 12.2848 13.9496C12.4207 14.2777 12.6427 14.5362 12.951 14.7251C13.2625 14.9141 13.652 15.0085 14.1193 15.0085C14.5866 15.0085 15.0076 14.9141 15.3821 14.7251C15.7566 14.5362 16.0632 14.2777 16.3018 13.9496C16.5405 13.6181 16.6946 13.2403 16.7642 12.8161L17.843 6.31818Z"
      fill="#BBBBBB"
    />
  </Base>
)

export default IndiaU
